import { useState } from 'react';
import { Globe, FileText, StickyNote } from 'lucide-react';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Textarea from '../ui/Textarea';
import Badge from '../ui/Badge';
import Card, { CardContent } from '../ui/Card';

export default function VoiceProfileForm({ onGenerate, loading }) {
  const [url, setUrl] = useState('');
  const [transcript, setTranscript] = useState('');
  const [notes, setNotes] = useState('');

  const handleGenerate = () => {
    if (!url.trim()) return;
    onGenerate({ url: url.trim(), transcript, notes });
  };

  return (
    <Card>
      <CardContent className="space-y-6">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 mb-1">
            Build Your Voice Profile & ICP
          </h2>
          <p className="text-sm text-slate-500">
            We'll analyze your company to create a personalized communication style and define your ideal customers.
          </p>
        </div>

        {/* Website URL */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-slate-400" />
            <span className="text-sm font-medium text-slate-700">Company Website</span>
          </div>
          <Input
            placeholder="https://yourcompany.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>

        {/* Interview Transcript */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <FileText className="w-4 h-4 text-slate-400" />
            <span className="text-sm font-medium text-slate-700">Interview Transcript</span>
            <Badge variant="default">OPTIONAL</Badge>
          </div>
          <Textarea
            placeholder="Paste a sales call transcript or interview notes here. This helps us capture your natural speaking style..."
            value={transcript}
            onChange={(e) => setTranscript(e.target.value)}
            hint="The more natural speech we have, the better the voice profile."
          />
        </div>

        {/* Additional Notes */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <StickyNote className="w-4 h-4 text-slate-400" />
            <span className="text-sm font-medium text-slate-700">Additional Notes</span>
            <Badge variant="default">OPTIONAL</Badge>
          </div>
          <Textarea
            placeholder="Anything else we should know about your business, target market, or communication preferences..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        {/* Generate Button */}
        <div className="pt-2">
          <Button
            size="lg"
            onClick={handleGenerate}
            loading={loading}
            disabled={!url.trim()}
            className="w-full"
          >
            Generate Voice Profile & ICP
          </Button>
          {!url.trim() && (
            <p className="text-xs text-slate-400 text-center mt-2">
              Enter your website URL to get started
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
